import { useNavigate } from "react-router-dom";
import FeedItem from "./FeedItem";
import FollowButton from "../Post/FollowButton";
import { useAuth } from "../AuthPage/AuthContext";

const FeedContainer = ({
  username, chat, quote, profile_icon,
  postAuthorId, profile_id, is_following,
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAuthor = !!(postAuthorId && user?.id && String(postAuthorId) === String(user.id));

  return (
    <div className="h-full flex flex-col gap-5 min-h-0">

      {/* Profile row */}
      <div className="flex items-center gap-3 shrink-0">
        {/* Avatar — clickable */}
        <div
          onClick={() => username && navigate(`/profile/${username}`)}
          className="relative w-12 h-12 rounded-2xl overflow-hidden shrink-0
            bg-gradient-to-br from-white/10 to-white/5
            border border-white/[0.08] hover:border-white/25 transition-all duration-300
            flex items-center justify-center cursor-pointer"
        >
          <span className="text-white font-bold text-xl select-none">
            {(username || "?")[0].toUpperCase()}
          </span>
          {profile_icon && (
            <img
              src={profile_icon}
              alt="profile"
              className="absolute inset-0 w-full h-full object-cover"
              onError={(e) => { e.target.style.display = "none"; }}
            />
          )}
        </div>

        {/* Username — clickable */}
        <div
          onClick={() => username && navigate(`/profile/${username}`)}
          className="flex-1 min-w-0 cursor-pointer group"
        >
          <p className="text-white font-semibold text-base tracking-tight
            group-hover:text-white/80 transition-colors leading-tight truncate">
            @{username}
          </p>
          {chat && (
            <p className="text-white/40 text-xs mt-0.5 truncate">{chat}</p>
          )}
        </div>

        {/* Follow button — right side, stop propagation so nav doesn't fire */}
        {profile_id && !isAuthor && (
          <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
            <FollowButton profileId={profile_id} initialFollowing={is_following} />
          </div>
        )}
      </div>

      {/* Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent shrink-0" />

      {/* Quote — scrollable, fills space */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <FeedItem quote={quote} />
      </div>

    </div>
  );
};

export default FeedContainer;
